// extracted by mini-css-extract-plugin
module.exports = {"container":"Language_container__1nU11","popup":"Language_popup__3uB7x","bubble":"Language_bubble__2VWIw","inList":"Language_inList__2dGDl","backdrop":"Language_backdrop__2rkdj"};